import { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Menu, X, Clock } from "lucide-react";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { COMPANY, waLink } from "@/data/company";
import { SERVICES } from "@/data/services";
import { serviceUrl } from "@/lib/routes";

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="bg-brand-dark text-white text-xs md:text-sm py-1.5 px-4 flex items-center justify-center gap-2 font-medium" data-testid="topbar-24h">
        <Clock size={14} className="text-brand-yellow" />
        <span>Atendimento <strong className="text-brand-yellow">24 HORAS</strong> em Guarulhos — inclusive feriados</span>
      </div>
      <header className="sticky top-0 z-50 bg-white shadow-md" data-testid="site-header">
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center" data-testid="header-logo-link" aria-label="Desentupidora em Guarulhos - Página inicial">
            <img src="/images/logo-guarulhos.png" alt="Desentupidora em Guarulhos" className="h-12 md:h-16 w-auto" width="220" height="64" />
          </Link>

          <nav className="hidden lg:flex items-center gap-6 font-medium text-sm text-brand-dark" aria-label="Menu principal">
            <Link to="/" className="hover:text-brand-red transition-colors" data-testid="nav-home">Início</Link>
            <div className="relative group">
              <span className="hover:text-brand-red transition-colors cursor-pointer py-6" data-testid="nav-servicos">Serviços</span>
              <div className="absolute top-full left-0 bg-white shadow-xl rounded-lg py-2 w-72 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all border border-gray-100">
                {SERVICES.map((s) => (
                  <Link key={s.slug} to={serviceUrl(s)} className="block px-4 py-2.5 text-sm hover:bg-brand-light hover:text-brand-red transition-colors" data-testid={`nav-servico-${s.slug}`}>
                    {s.nome}
                  </Link>
                ))}
              </div>
            </div>
            <Link to="/bairros-atendidos" className="hover:text-brand-red transition-colors" data-testid="nav-bairros">Bairros Atendidos</Link>
            <Link to="/blog" className="hover:text-brand-red transition-colors" data-testid="nav-blog">Blog</Link>
            <Link to="/sobre" className="hover:text-brand-red transition-colors" data-testid="nav-sobre">Sobre</Link>
            <Link to="/contato" className="hover:text-brand-red transition-colors" data-testid="nav-contato">Contato</Link>
          </nav>

          <div className="flex items-center gap-2">
            <a href={`tel:${COMPANY.telefoneRaw}`} className="hidden md:flex items-center gap-2 bg-brand-red hover:bg-brand-redDark text-white font-heading font-bold px-4 py-2.5 rounded-full text-sm transition-colors" data-testid="header-call-btn">
              <Phone size={16} /> {COMPANY.telefone}
            </a>
            <a href={waLink()} target="_blank" rel="noopener noreferrer" className="hidden sm:flex items-center gap-2 bg-brand-green hover:bg-brand-greenHover text-white font-heading font-bold px-4 py-2.5 rounded-full text-sm transition-colors" data-testid="header-whatsapp-btn">
              <WhatsAppIcon /> Chamar no WhatsApp
            </a>
            <a href={`tel:${COMPANY.telefoneRaw}`} className="md:hidden flex items-center gap-1.5 bg-brand-red text-white font-bold px-3 py-2 rounded-full text-xs" data-testid="header-call-btn-mobile">
              <Phone size={14} /> Ligar
            </a>
            <button className="lg:hidden p-2 text-brand-dark" onClick={() => setOpen(!open)} aria-label="Abrir menu" data-testid="mobile-menu-toggle">
              {open ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {open && (
          <nav className="lg:hidden bg-white border-t border-gray-100 px-4 py-4 space-y-1 shadow-lg" aria-label="Menu mobile" data-testid="mobile-menu">
            <Link to="/" onClick={() => setOpen(false)} className="block py-2.5 font-medium" data-testid="mobile-nav-home">Início</Link>
            {SERVICES.map((s) => (
              <Link key={s.slug} to={serviceUrl(s)} onClick={() => setOpen(false)} className="block py-2 pl-3 text-sm text-gray-600" data-testid={`mobile-nav-${s.slug}`}>{s.nome}</Link>
            ))}
            <Link to="/bairros-atendidos" onClick={() => setOpen(false)} className="block py-2.5 font-medium" data-testid="mobile-nav-bairros">Bairros Atendidos</Link>
            <Link to="/blog" onClick={() => setOpen(false)} className="block py-2.5 font-medium" data-testid="mobile-nav-blog">Blog</Link>
            <Link to="/sobre" onClick={() => setOpen(false)} className="block py-2.5 font-medium" data-testid="mobile-nav-sobre">Sobre</Link>
            <Link to="/contato" onClick={() => setOpen(false)} className="block py-2.5 font-medium" data-testid="mobile-nav-contato">Contato</Link>
          </nav>
        )}
      </header>
    </>
  );
};
